import { useEffect, useState } from "react";
import { GetPaymentGatewayApi } from "../../../../../api/request/wallet/deposit";

export default function WalletDeposit() {
      const [isLoading, setIsLoading] = useState(true);
      const [data, setData] = useState([]);
    
      const getPaymentGateway = async () => {
        try {
          setIsLoading(true);
          const { data } = await GetPaymentGatewayApi(1);
          if (data?.success) {
            setData(data?.data || []);
          }
          setIsLoading(false);
        } catch (error) {
          setData([]);
          setIsLoading(false);
        }
      }
        useEffect(() => {
          getPaymentGateway();
        }, [])
  return (
    <div className="max-w-3xl mx-auto mt-10  bg-white rounded shadow-lg border">
         <div className="p-6">
           <h2 className="text-xl font-semibold flex items-center gap-2">
             Deposit 
           </h2>
         </div>
        <hr />
        <div className="max-w-md mx-auto">
          <div className="mb-6 p-6">
              <label className="block text-sm font-medium mb-2">Amount</label>
          <div className="flex gap-2">
            <div className="flex items-center flex-1 border  border-gray-300 rounded px-3 py-2">
              <img src="assets/icons/dollar.svg" alt="" className="me-2"/>
              <input
                type="number"
                className="flex-1 outline-none bg-transparent"
                placeholder="Enter amount"
              />
            </div>
            <button className="text-gray-600 font-bold border border-gray-300 py-2 px-4 rounded">
              $
            </button>
          </div>
          </div>
        </div>
        <hr />
        <div className="p-6 max-w-md mx-auto">
            <div className="mb-6">
              <h3 className="text-lg font-bold">
                    Transfer Method
              </h3>

              <div className="flex gap-3 mt-4 flex-wrap">
                {data.map((item) => (
                  <div key={item.id} className="p-4 border rounded shadow-sm flex items-center gap-2">
                    <img
                      src={item?.paymentLogoUrl}
                      alt={item?.title}
                      width={30}
                      height={30}
                      className="object-contain"
                    />
                    <div>{item?.name}</div>
                  </div>
                ))}
              </div>
        </div>

        <div className="flex gap-4 my-10">
            <button className="bg-primary text-sm text-white font-semibold px-8 py-3 rounded-lg themeHover duration-500">
              Deposit
            </button>
            <button className="bg-primary-light text-sm primary font-semibold px-8 py-3 rounded-lg duration-500">
              Cancel
            </button>
        </div>
    </div>
    </div>
  );
}
